<template>
  <div class='t_content_view'>
    <!-- 标题 -->
    <div class="t_title_box_f">
        <div class="t_blue_line"></div>
        <div>账号基础信息</div>
    </div>
    <div class="t_mine_info_box_f">
      <div class="t_mine_info_box">
        账号名称：{{ user_info.data.username }}
      </div>
      <div class="t_mine_info_box">
        登录密码：{{ user_info.data.password }}
        <el-button @click="openpwd" class="t_tool_btn"  type="text" color="#4F46E5"> 修改 </el-button>
      </div>
      <div class="t_mine_info_box">
        联系电话：{{ user_info.data.phone }}
        <el-button  @click="openphone" class="t_tool_btn" type="text" color="#4F46E5"> 修改 </el-button>
      </div>
    </div>
    <hr style="border: none; border-top: 1px solid #DFDFDF;margin-top: 40px;margin-bottom: 40px;" />
    <!-- 标题 -->
    <div class="t_title_box_f">
        <div class="t_blue_line"></div>
        <div>平台绑定</div>
    </div>
    <div class="t_mine_comp_box">
      <div class="t_mine_comp_title">敢探号平台</div>
      <div class="t_mine_comp_box_f">
        <div style="font-weight: 500;">我的应用凭证</div>
        <div class="t_mine_info_box">
          APPID：{{ ght_info.data.app_id }}
          <el-button @click="copyToClipboard(ght_info.data.app_id)"  v-if="isshowview" class="t_tool_btn"  type="text" color="#4F46E5"> 复制 </el-button>
        </div>
        <div class="t_mine_info_box">
          app key：{{ ght_info.data.app_key }}
          <el-button @click="copyToClipboard(ght_info.data.app_key)" v-if="isshowview"  class="t_tool_btn" type="text" color="#4F46E5"> 复制 </el-button>
        </div>
        <div class="t_mine_info_box">
          回调地址：{{ ght_info.data.callback_url }}
          <el-button @click="copyToClipboard(ght_info.data.callback_url)" v-if="isshowview" class="t_tool_btn" type="text" color="#4F46E5"> 复制 </el-button>
        </div>
        <el-button  @click="viewset" size="small" type="primary" color="#4F46E5"> 查看 </el-button>
      </div>
      <div class="t_mine_comp_box_f">
        <div style="font-weight: 500;">敢探号凭证填写</div>
        <div class="t_mine_info_box">
          APPID：
          
          <el-input v-if="isshowappid" v-model="newplatform_app_id" class="t_gth_input" type="text"  placeholder="请输入APPID"  clearable />
          <span v-else>{{ ght_info.data.platform_app_id }}</span>
          
          <el-button v-if="isshowappid" @click="qxght(1)" class="t_tool_btn"  type="text" color="#4F46E5"> 取消 </el-button>
          <el-button v-else @click="editght(1)" class="t_tool_btn"  type="text" color="#4F46E5"> 修改 </el-button>
        </div>
        <div class="t_mine_info_box">
          app key：
          
          <el-input v-if="isshowappkey"  v-model="newplatform_app_key" class="t_gth_input" type="text"  placeholder="请输入app key"  clearable />
          <span v-else>{{ ght_info.data.platform_app_key }}</span>
          
          <el-button v-if="isshowappkey" @click="qxght(2)" class="t_tool_btn"  type="text" color="#4F46E5"> 取消 </el-button>
          <el-button v-else @click="editght(2)" class="t_tool_btn"  type="text" color="#4F46E5"> 修改 </el-button>
        </div>
        <div class="t_mine_info_box">
          回调地址：
          
          <el-input v-if="isshowcallback" v-model="newplatform_callback_url" class="t_gth_input" type="text"  placeholder="请输入回调地址"  clearable />
          <span v-else>{{ ght_info.data.platform_callback_url }}</span>
          <el-button v-if="isshowcallback" @click="qxght(3)" class="t_tool_btn"  type="text" color="#4F46E5"> 取消 </el-button>
          <el-button v-else @click="editght(3)" class="t_tool_btn"  type="text" color="#4F46E5"> 修改 </el-button>
        </div>
        <el-button  @click="saveset" type="primary" color="#4F46E5"> 确定保存 </el-button>
      </div>
      
    </div>
        <!-- <div class="t_con_box_f" style="align-items:center">
            <div class="t_con_title_f">绑定手机号：</div>
            <div>
                <el-input @input="handleEdit" v-model="phone" type="text" maxlength="11"  style="width: 600px;"  placeholder="请输入手机号"  clearable />
            </div>
        </div> -->
       
  </div>

  <!-- 修改密码 -->
   <el-dialog
    v-model="isshowpwd"
    title="修改密码"
    width="500px"
    :close-on-click-modal="false"
  >
    <el-input  type="text" v-model="newpwd" placeholder="请输入新密码"  clearable />
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="isshowpwd = false">取消</el-button>
        <el-button type="primary" @click="savepwd">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
  <!-- 修改手机号 -->
   <el-dialog
    v-model="isshowphone"
    title="修改手机号"
    width="500px"
    :close-on-click-modal="false"
  >
    <el-input  type="text" @input="handleEdit" maxlength="11" v-model="newphone" placeholder="请输入新手机号"  clearable />
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="isshowphone = false">取消</el-button>
        <el-button type="primary" @click="savephone">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>

</template>

<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,inject,watchEffect } from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
// const code = inject('auth_code')
//动态获取接口地址
import { newcompinfo,neweditpassword,neweditphonecom,neweditght,newcompsec } from '@/assets/js/common.js'
const _url2 = inject('_url2')
const _url = inject('_url')
import  useClipboard  from 'vue-clipboard3'
const { toClipboard } = useClipboard()


onMounted(() => {
  getinfo()
})

//平台信息
const user_info = reactive({
  data:{}
})

//敢探号凭证
const ght_info = reactive({
  data:{}
})

const getinfo = ()=>{
  newcompinfo().then(response=>{
    if (response.data.msg.code == 0) {
      console.log('平台信息')
      console.log(response.data)
      user_info.data = response.data.data.user_info
      ght_info.data = response.data.data.platform_info
    }
  })
}

// 显示密码弹窗
const isshowpwd = ref(false)
// 新密码
const newpwd = ref('')
//打开密码弹窗
const openpwd = ()=>{
  isshowpwd.value = true
  newpwd.value = ''
}
// 保存密码
const savepwd = ()=>{
  if(newpwd.value==''){
    ElMessage({
      message: '请输入新密码',
      type: 'warning'
    })
    return
  }

  neweditpassword({password:newpwd.value}).then(response=>{
    if (response.data.msg.code == 0) {
      ElMessage({
        message: '操作成功',
        type: 'success'
      })
      isshowpwd.value = false
      getinfo()
    }
  })


  
}

// 显示手机号弹窗
const isshowphone = ref(false)
// 新手机号
const newphone = ref('')
//打开手机号弹窗
const openphone = ()=>{
  isshowphone.value = true
  newphone.value = ''
}
// 保存手机号
const savephone = ()=>{
  if(newphone.value==''){
    ElMessage({
      message: '请输入新手机号',
      type: 'warning'
    })
    return
  }


  neweditphonecom({phone:newphone.value}).then(response=>{
    if (response.data.msg.code == 0) {
      ElMessage({
        message: '操作成功',
        type: 'success'
      })
       isshowphone.value = false
      getinfo()
    }
  })
 
}

//修改appid
const isshowappid = ref(false)

//修改appkey
const isshowappkey = ref(false)

//修改回调地址
const isshowcallback = ref(false)

// 修改后的appid
const newplatform_app_id = ref('')
// 修改后的appkey
const newplatform_app_key = ref('')
// 修改后的回调地址
const newplatform_callback_url = ref('')

//修改敢探号信息
const editght = (type)=>{
  if(type==1){
    isshowappid.value = true
    
    newplatform_app_id.value = JSON.parse(JSON.stringify(ght_info.data.platform_app_id))
  }else if(type==2){
    isshowappkey.value = true
    newplatform_app_key.value = JSON.parse(JSON.stringify(ght_info.data.platform_app_key))
  }else if(type==3){
    isshowcallback.value = true
    newplatform_callback_url.value = JSON.parse(JSON.stringify(ght_info.data.platform_callback_url))
  }
}
//取消修改
const qxght = (type)=>{
  if(type==1){
    isshowappid.value = false
  }else if(type==2){
    isshowappkey.value = false
  }else if(type==3){
    isshowcallback.value = false
  }
}





// 提交修改
const saveset = ()=>{
  if(isshowappid.value){
    if(newplatform_app_id.value==''){
      ElMessage({
        message: '请输入新appid',
        type: 'warning'
      })
      return
    }
    neweditght({platform_app_id:newplatform_app_id.value}).then(response=>{
      if (response.data.msg.code == 0) {
        isshowappid.value = false
        isshowappkey.value = false
        isshowcallback.value = false
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
        getinfo()
      }
    })
  }

  if(isshowappkey.value){
    if(newplatform_app_key.value==''){
      ElMessage({
        message: '请输入新appkey',
        type: 'warning'
      })
      return
    }
    neweditght({platform_app_key:newplatform_app_key.value}).then(response=>{
      if (response.data.msg.code == 0) {
        isshowappid.value = false
        isshowappkey.value = false
        isshowcallback.value = false
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
        getinfo()
      }
    })
  }

  if(isshowcallback.value){
    if(newplatform_callback_url.value==''){
      ElMessage({
        message: '请输入新回调地址',
        type: 'warning'
      })
      return
    }
    neweditght({platform_callback_url:newplatform_callback_url.value}).then(response=>{
      if (response.data.msg.code == 0) {
        isshowappid.value = false
        isshowappkey.value = false
        isshowcallback.value = false
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
        getinfo()
      }
    })
  }
  


  
}


//查看铭文
const isshowview = ref(false)
const viewset = ()=>{
  newcompsec({}).then(response=>{
    if (response.data.msg.code == 0) {
      console.log('我的铭文')
      console.log(response.data)

      ght_info.data.app_id = response.data.data.app_id
      ght_info.data.app_key = response.data.data.app_key
      ght_info.data.callback_url = response.data.data.callback_url

      isshowview.value = true
      ElMessage({
        message: '查看成功',
        type: 'success'
      })
    }
  })
  
}

// 在script部分添加复制函数
const copyToClipboard = async (text) => {
  try {
    await toClipboard(text)
    ElMessage({
      message: '复制成功',
      type: 'success'
    })
  } catch (error) {
    ElMessage({
      message: '复制失败',
      type: 'error'
    })
    console.error('复制失败:', error)
  }
}







// 在 Input 值改变时触发
const handleEdit = (e)=>{
      let value = e.replace(/[^\d]/g, ""); // 只能输入数字
      value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
      phone.value = value
}
//绑定手机号
const phone = ref('')

</script>

<style scoped>
.t_mine_info_box{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
}
.t_mine_info_box_f{
  margin-top: 30px;
  padding-left: 40px;
  font-size: 15px;
}
.t_mine_comp_box{
  background-color: #f4f5f5;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 20px;
}
.t_mine_comp_box_f{
  padding-left: 20px;
  margin-bottom: 30px;
  font-size: 15px;
}
.t_mine_comp_title{
  font-size:16px;
  font-weight: bold;
  margin-bottom: 15px;
}
.t_tool_btn{
  margin-left: 10px;
}
.t_gth_input{
  width: 300px;
  margin-left: 10px;
}
:deep( .t_gth_input .el-input__wrapper) {
  background-color: #F1F3F9;
  box-shadow: 0 0 0 0 black;
}
</style>
